/* eslint-disable no-use-before-define */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "search": "search",
      "close": "close",
      "reel": "reel",
      "music collection": "music collection",
      "playlists": "playlists",
      "about": "about",
      "contact": "contact",
      "faq": "faq",
      "login": "login",
      "my searches": "my playlists",
      "tips": "tips",
      "view favorites": "view favorites",
      "video sync": "video sync",
      "reset keywords": "reset keywords",
      "clear all likes": "clear favorites",
      "clear all waveforms": "clear all waveforms",
      "yes": "yes",
      "search total": "search total",
      "track length": "track length",
      "cancel": "cancel",
      "like": "like",
      "play": "play",
      "all": "all",
      "reset search": "reset search",
      "help": "",
      "alternate versions": "alternatve versions",
      "sub genres": "sub genres",
      "genres": "genres",
      "keywords": "keywords",
      "download": "download",
      "video tutorials": "video tutorials",
      "accept": "accept",
      "japanese": "日本語",
      "acoustic": "acoustic",
      "lighter side": "light",
      "rock": "rock",
      "thoughtful": "thoughtful",
      "quirky": "quirky",
      "electronic": "electronic",
      "orchestral": "orchestral",
      "hip hop": "hip hop",
      "retro": "retro",
      "ambient": "ambient",
      "international": "international",
      "jazz": "jazz",
      "hopeful": "hopeful",
      "warm": "warm",
      "ironic": "ironic",
      "sentimental": "sentimental",
      "anthemic": "anthemic",
      "happy": "happy",
      "dreamy": "dreamy",
      "tension": "tension",
      "twang": "twang",
      "playful": "playful",
      "cinematic": "cinematic",
      "energetic": "energetic",
      "dark": "dark",
      "gritty": "gritty",
      "minimal": "minimal",
      "organic": "organic",
      "delicate": "delicate",
      "mellow": "mellow",
      "action": "action",
      "romantic": "romantic",
      "indie": "indie",
      "mysterious": "mysterious",
      "fashion": "fashion",
      "funk": "funk",
      "magical": "magical",
      "holiday": "holiday",
      "vocal": "vocal",
      "pop": "pop",
      "mnemonic": "mnemonic",
      "drums": "drums",
      "sports": "sports",
      "heroic": "heroic",
      "builds": "builds",
      "blues": "blues",
      "classical": "classical",
      "marching band": "marching band",
      "opera": "opera",
      "solo piano": "solo piano",
      "country": "country",
      "disco": "disco",
      "folk": "folk",
      "gospel": "gospel",
      "african": "african",
      "asian": "asian",
      "east european": "east european",
      "french": "french",
      "german": "german",
      "hawaiian": "hawaiian",
      "irish": "irish",
      "italian": "italian",
      "latin": "latin",
      "middle eastern": "middle eastern",
      "reggae": "reggae",
      "india": "india",
      "bossa nova": "bossa nova",
      "jazz ballad": "jazz ballad",
      "bebop": "bebop",
      "big band/swing": "big band/swing",
      "exotica": "exotica",
      "latin jazz": "latin jazz",
      "old time jazz": "old time jazz",
      "spy jazz": "spy jazz",
      "lounge": "lounge",
      "elevator": "elevator",
      "new age": "new age",
      "polka": "polka",
      "r&b": "r&b",
      "alternative": "alternative",
      "southern rock": "southern rock",
      "metal": "metal",
      "psychedelic": "psychedelic",
      "punk rock": "punk rock",
      "prog rock": "prog rock",
      "surf rock": "surf rock",
      "ska": "ska",
      "soul": "soul",
      "fifties": "fifties",
      "sixties": "sixties",
      "seventies": "seventies",
      "eighties": "eighties",
      "driving": "driving",
      "epic": "epic",
      "innocent": "innocent",
      "inspirational": "inspirational",
      "pulsating": "pulsating",
      "sad": "sad",
      "electronic pop": "electronic pop",
      "downtempo": "downtempo",
      "dance/house": "dance/house",
      "aggressive": "aggressive",
      "tango": "tango",
      "new orleans": "new orleans",
      "acoustic pop": "acoustic pop",
      "happy pop": "happy pop",
      "indie pop": "indie pop",
      "folk rock": "folk rock",
      "indie rock": "indie rock",
      "light rock": "light rock",
      "pop rock": "pop rock",
      "90's rock": "90's rock",
      "comedic": "comedic",
      "sneaky": "sneaky",
      "sophisticated": "sophisticated",
      "positive": "positive",
      "tough": "tough",
      "get playlist link": "get playlist link",
      "download all likes": "download favorites",
      "back to search": "back to search",
      "load new video": "load new video",
      "music level": "music level",
      "video level": "video level",
      "videosync_a": "video sync tool",
      "videosync_b": "drag a video to preview or click here to select a file from your computer",
      "videosync_c": "this video will <strong>not</strong> be uploaded to any server or cloud",
      "length": "length",
      "track title": "a&s track title",
      "new": "new",
      "show alternate versions": "show alternate versions",
      "hide alternate versions": "hide alternate versions",
      "agreement":"You warrant and agree that you shall not upload, post, publish, transmit, reproduce, distribute or in any way exploit the material obtained through or derived from this website for commercial purposes until you execute a license agreement provided to you by contacting",
      "watch video tutorial": "watch video tutorial",
      "faster playback": "for faster playback, try using the return/enter key",
      "use the plus":
        "use the plus and minus keys on your keyboard to like or unlike tracks quickly",
      "action-description":
        "Music to accompany a wide variety of action sequences, from modern to retro",
      "anthemic-description":
        "Uplifting music often building to a positive crescendo",
      "builds-description":
        "Music that starts small and expands over time growing in instrumentation, and emotional impact",
      "cinematic-description":
        "Music created for the moods and images of feature films",
      "dark-description":
        "Music ranging in mood from quiet and somber to scary and sinister",
      "delicate-description":
        "Light music that uses sparse and thoughtful instrumentation",
      "dreamy-description":
        "Ethereal music with an unhurried and reflective mood",
      "driving-description":
        "Urgent music that pushes forward with power and momentum",
      "elevator-description":
        "Muzak sounding tracks often heard in the confines of an elevator",
      "energetic-description": "Music with an active, spirited energy",
      "epic-description": "Music that is bold, heroic, and majestic",
      "fashion-description": "Music that has a modern runway/club/house feel",
      "gritty-description":
        "Music with an aggressive, forceful bite",
      "heroic-description":
        "Music across many genres that projects a courageous, valiant, heroic feeling",
      "holiday-description": "Music befitting the winter holiday season",
      "hopeful-description":
        "Inspiring music that offers a positive feeling of hope",
      "indie-description": "Music with an inspired indie band sound",
      "innocent-description":
        "Music with the heart of a child. Pure, clear and genuine",
      "inspirational-description": "Music that is positive and uplifting",
      "ironic-description":
        "Playful ironic executions at iconic musical styles",
      "lighterside-description":
        "Optimistic music that feels energetic, shiny, and bright",
      "magical-description":
        "Music that is beautiful, wondrous, and enchanting",
      "minimal-description":
        "Music that is expressive itself with very few instruments",
      "mnemonic-description":
        "Short simple musical pieces in a wide range of styles",
      "mysterious-description": "Music with an enigmatic mysterious tone",
      "organic-description":
        "Music performed on real instruments played by live musicians",
      "playful-description":
        "Music with lighted hearted instrumentation and tone",
      "positive-description":
        "Music in many styles that conveys a buoyant optimistic tone",
      "pulsating-description":
        "Music with a distinct energy and repeating pulse",
      "quirky-description": "Playful music that uses unusual instrumentation",
      "retro-description":
        "Music from the past across all genres, from 1930s to the 80s",
      "romantic-description": "Music evoking a sense of romance",
      "sad-description": "Melancholy music that is heavy on the heart",
      "sentimental-description": "Music with a tender, delicate emotion",
      "sneaky-description":
        "Music in many styles that is sly, crafty, and mischievous",
      "sophisticated-description":
        "Music that is elegant, refined and stylish",
      "sports-description":
        "Powerful dynamic music created for the sports enthusiast",
      "happy-description": "Lighthearted music that is cheerful and happy",
      "tension-description": "Music conveying uncertainty and apprehension",
      "thoughtful-description":
        "Music that is reflective, contemplative and introspective",
      "tough-description": "Music that feels strong, sturdy, rugged, and solid",
      "twang-description": "Music with a country/folk influence",
      "vocal-description": "Music that uses the human voice",
      "warm-description": "Welcoming music with a friendly tone",
      "click genres and keywords to begin search":
        "click genres and keywords to begin search",
      "keyword description": "keyword description",
      "site guide": "site guide",
      "add more keywords to refine search":
        "add more keywords to refine search",
      "drone": "drone",
      "bold-description": "Music that has brash and striking quality",
      "calm-description": "Serene and unhurried music",
      "comedic-description": "Quirky, playful music that can underscore comedic visuals",
      "confident-description": "Daring and intrepid music that leaves an impact",
      "lush-description": "Luxurious and evocative music ",
      "mischievous-description": "Music in many styles that is sly and crafty",
      "seductive-description": "Alluring and moody music",
      "upbeat-description": "Positive music that is up in tempo",
      "whimsical-description": "Music that is fanciful and quaint"
    }
  },
  ja: {
    translation: {
      "search": "探す",
      "close": "閉じる",
      "reel": "実績紹介",
      "music collection": "音楽コレクション",
      "playlists": "プレイリスト",
      "about": "事業紹介",
      "contact": "お問合せ",
      "faq": "よくある質問",
      "login": "ログイン",
      "my searches": "マイサーチ",
      "tips": "ヒント",
      "view favorites": "いいねを全て見る",
      "video sync": "ビデオ同期",
      "reset keywords": "検索リセット",
      "clear all likes": "お気に入りを削除する",
      "clear all waveforms": "全ての波形をクリア",
      "yes": "同意する",
      "search total": "検索結果",
      "track length": "演奏時間",
      "cancel": "キャンセル",
      "like": "お気に入り",
      "play": "再生",
      "all": "すべて",
      "reset search": "検索リセット",
      "help": "ヘルプ",
      "alternate versions": "別バージョンを表示する",
      "sub genres": "サブジャンル",
      "genres": "ジャンル",
      "keywords": "キーワード",
      "download": "ダウンロード",
      "video tutorials": "チュートリアル",
      "accept": "同意する",
      "japanese": "日本語",
      "acoustic": "ｱｺｰｽﾃｨｯｸ",
      "lighter side": "ピカピカ",
      "rock": "ロック",
      "thoughtful": "マインドフルネス",
      "quirky": "お茶目",
      "electronic": "電子音楽",
      "orchestral": "オーケストラ",
      "hip hop": "ヒップホップ",
      "retro": "ロマンティック",
      "ambient": "アンビエント",
      "international": "世界の音楽",
      "jazz": "ジャズ",
      "hopeful": "希望・前向き",
      "warm": "ぽかぽか",
      "ironic": "遊び心",
      "sentimental": "切ない",
      "anthemic": "賛歌的",
      "happy": "キラキラ",
      "dreamy": "幻想的",
      "tension": "ザワザワ",
      "twang": "ジャガジャガ",
      "playful": "爽やか",
      "cinematic": "ドラマティック",
      "energetic": "ギラギラ",
      "dark": "暗い",
      "gritty": "ザラザラ",
      "minimal": "シンプル",
      "organic": "ライブ",
      "delicate": "繊細",
      "mellow": "柔らかい",
      "action": "アクション",
      "romantic": "ロマンチック",
      "indie": "インディーズ",
      "mysterious": "ミステリアス",
      "fashion": "おしゃれ",
      "funk": "ファンク",
      "magical": "チル、穏やか",
      "holiday": "クリスマス",
      "vocal": "ポジティブ",
      "pop": "ポップ　",
      "mnemonic": "サウンドロゴ",
      "drums": "ドラム",
      "sports": "思慮深い",
      "heroic": "ヒーロー",
      "builds": "ドラマティック",
      "blues": "ブルース",
      "classical": "クラシック音楽",
      "marching band": "マーチングバンド",
      "opera": "オペラ",
      "solo piano": "ピアノソロ",
      "country": "カントリー",
      "disco": "ディスコ",
      "folk": "フォーク",
      "gospel": "ゴスペル",
      "african": "アフリカ",
      "asian": "アジア",
      "east european": "東欧",
      "french": "フランス",
      "german": "ドイツ",
      "hawaiian": "ハワイアン",
      "irish": "アイルランド",
      "italian": "イタリア",
      "latin": "ラテン",
      "middle eastern": "中東",
      "reggae": "レゲエ",
      "india": "インド",
      "bossa nova": "ボサノヴァ",
      "jazz ballad": "ジャズバラード",
      "bebop": "ビバップ",
      "big band/swing": "ビッグバンド、スウィング",
      "exotica": "エキゾチカ",
      "latin jazz": "ラテンジャズ",
      "old time jazz": "オールドタイムジャズ",
      "spy jazz": "スパイ・ジャズ",
      "lounge": "ラウンジ",
      "elevator": "保留音",
      "new age": "ニューエイジ",
      "polka": "ポルカ",
      "r&b": "r&b",
      "alternative": "90年代ロック",
      "southern rock": "サザン・ロック",
      "metal": "メタル",
      "psychedelic": "サイケデリック",
      "punk rock": "パンク・ロック",
      "prog rock": "プログレッシブ・ロック",
      "surf rock": "サーフ・ロック",
      "ska": "スカ",
      "soul": "ソウル",
      "fifties": "1950年代",
      "sixties": "1960年代",
      "seventies": "1970年代",
      "eighties": "1980年代",
      "driving": "激しい",
      "epic": "壮大",
      "innocent": "純粋",
      "inspirational": "感動的",
      "pulsating": "ドキドキ",
      "sad": "悲しい",
      "electronic pop": "エレクトロ・ポップ",
      "downtempo": "ダウンテンポ",
      "dance/house": "EDM、ハウス",
      "aggressive": "ハードコア",
      "tango": "タンゴ",
      "new orleans": "ニューオーリンズ",
      "acoustic pop": "アコースティック・ポップ",
      "happy pop": "ハッピー・ポップ",
      "indie pop": "インディー・ポップ",
      "folk rock": "フォーク・ロック",
      "indie rock": "インディー・ロック",
      "light rock": "ライト・ロック",
      "pop rock": "ポップ・ロック",
      "90's rock": "90年代ロック",
      "comedic": "お笑い",
      "sneaky": "コソコソ",
      "sophisticated": "洗練された",
      "positive": "鼓動",
      "tough": "パワフル",
      "get playlist link": "検索リンクを取得",
      "download all likes": "いいねを全てDL",
      "back to search": "検索に戻る",
      "load new video": "新しいビデオをロード",
      "music level": "音楽レベル",
      "video level": "ビデオレベル",
      "videosync_a": "ビデオ同期では、お客様の映像に合った音楽を検索できます",
      "videosync_b":
        "こちらをクリックし、パソコンからビデオファイルを選択してください",
      "videosync_c":
        "ビデオはサーバーまたはクラウドにアップロードされず、お使いのコンピュータから直接再生されます。",
      "length": "長さ",
      "track title": "トラックタイトル",
      "new": "新着",
      "show alternate versions": "代替バージョンを表示",
      "hide alternate versions": "代替バージョンを非表示",
      "agreement":
        "お客様はAsche & Spencer Music Inc.が提供するライセンス契約を締結するまで、本ウェブサイトを通じて取得または派生した素材を商業目的でアップロード、投稿、公開、送信、複製、配布、または悪用しないことを保証し、それに合意するものとします",
      "watch video tutorial": "説明動画を見る",
      "faster playback": "高速再生には、エンターキーをご利用下さい",
      "use the plus":
        "キーボード上のプラスキーとマイナスキーを使って、すばやくトラックの「いいね」を付け外しできます。",
      "action-description":
        "幅広いアクションシークエンスを表現する音楽。レトロなものから現代的なものまで",
      "anthemic-description":
        "ポジティブな高まりを築いていく、気持ちを高揚させる音楽",
      "builds-description":
        "小さな音から始まり徐々に大音量の楽器演奏へと広がる、感情的な印象のある音楽",
      "cinematic-description": "映画のイメージや雰囲気に合わせて作られた音楽",
      "dark-description":
        "静かで憂鬱な雰囲気から、恐ろしくて邪悪な雰囲気まで表現する音楽",
      "delicate-description": "わずかな楽器のみで奏でる、軽く繊細な音楽",
      "dreamy-description": "ゆっくりとした黙想的な雰囲気を持つ精神的な音楽",
      "driving-description": "スピード感溢れる、強烈なインパクトの音楽",
      "elevator-description": "エレベーター内でよく流れるようなBGM音楽",
      "energetic-description": "攻撃的なエネルギーを感じさせる音楽",
      "epic-description": "勇敢で雄大な音楽",
      "fashion-description":
        "現代的なランウェイ、クラブ、ハウス的な雰囲気を持つ音楽",
      "gritty-description": "攻撃的なキレがある音楽。力強いギターとドラム",
      "heroic-description":
        "勇敢で雄々しく英雄的な感情を表す様々なジャンルにまたがる音楽",
      "holiday-description": "クリスマスシーズンにふさわしい音楽",
      "hopeful-description": "希望に溢れた前向きな気持ちを引き出す音楽",
      "indie-description": "インディーズバンドのサウンドに影響を受けた音楽",
      "innocent-description": "子供のように純粋な、清らかな音楽",
      "inspirational-description": "ポジティブで気持ちが上向きになるような音楽",
      "ironic-description":
        "スタンダードなジャンルを遊び心溢れるスタイルで奏でた音楽",
      "lighterside-description": "活気、輝きや明るさを感じる楽観的な音楽",
      "magical-description": "美しく、不思議で、魅力的な音楽",
      "minimal-description": "ごく限られた数の楽器で表現する音楽",
      "mnemonic-description": "様々なスタイルで演奏する、短くシンプルな音楽",
      "mysterious-description": "不思議で、神秘的なトーンの音楽",
      "organic-description":
        "ライブミュージシャンによる本物の楽器で演奏される音楽",
      "playful-description": "陽気な演奏や陽気なトーンの音楽",
      "positive-description":
        "軽快で楽観的なトーンを伝える様々なスタイルの音楽",
      "pulsating-description": "独特なエネルギーを持つ、拍動感がある音楽",
      "quirky-description": "珍しい楽器を使った、陽気な音楽",
      "retro-description":
        "すべてのジャンルを含む過去の音楽。1930年代から1980年代まで",
      "romantic-description": "ロマンス感を呼び起こす音楽",
      "sad-description": "心に重い、憂鬱の音楽",
      "sentimental-description": "柔らかく、繊細な感情の音楽",
      "sneaky-description":
        "様々なスタイルの、ずるしく、巧妙で、いたずらな音楽",
      "sophisticated-description": "エレガントで洗練されたスタイリッシュな音楽",
      "sports-description":
        "スポーツ愛好家のために作られた力強くダイナミックな音楽",
      "happy-description": "陽気で幸せな気楽な音楽",
      "tension-description": "不確かさと不安を感じる音楽",
      "thoughtful-description": "自分自身の内側に目を向けるような音楽",
      "tough-description": "強く頑丈、無骨でかっこいい感じの音楽",
      "twang-description": "カントリーやフォークの影響を受けた音楽",
      "vocal-description": "人間の声を使った音楽",
      "warm-description": "フレンドリーなトーンの歓迎的な音楽",
      "click genres and keywords to begin search":
        "ジャンルとキーワードをクリックして検索開始",
      "keyword description": "キーワードの説明",
      "site guide": "サイトガイド",
      "add more keywords to refine search":
        "検索を絞り込むためのキーワードを追加",
      "drone": "ドローン"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    
    detection: {
      // Check localStorage first, then browser language
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n;
